import React from "react";
import Block from "../Block";
import LinePlaceholder from "../LinePlaceholder";

type Props = {
  marginBottom?: number;
  marginTop?: number;
  width?: number;
};

const TestimonialPlaceholder = ({ marginBottom = 0, marginTop = 0, width = 100 }: Props) => {
  return (
    <Block marginTop={marginTop} marginBottom={marginBottom}>
      <Block row marginBottom={1}>
        <LinePlaceholder borderRadius={100} width={5} height={5.5} />
        <Block flex={1} marginLeft={1.75} justifyCenter>
          <LinePlaceholder borderRadius={1} width={10} height={2} />
          <LinePlaceholder borderRadius={1} width={10} height={2} />
        </Block>
      </Block>

      <LinePlaceholder borderRadius={1} width={15} height={3} marginTop={1} />

      <LinePlaceholder borderRadius={1} width={width} height={5} marginTop={1} />

      <LinePlaceholder borderRadius={1} width={10} height={2.5} marginTop={3} />
    </Block>
  );
};

export default React.memo(TestimonialPlaceholder);
